export default __webpack_public_path__ + "static/media/yamaha-yzf-r15-right-side-view0.13b87cc9.jpeg";